import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMoreSpaces } from "../../Redux/Thunks/moreSpaceThunks";
import Typography from "../../Utility/Typography";
import "./moreSpacesPopup.css";

const MoreSpacesPopup = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const { list, loading } = useSelector((state) => state.moreSpaces);
  //   console.log("more spaces..........",moreSpaces);

  useEffect(() => {
    if (open) {
      dispatch(fetchMoreSpaces());
    }
  }, [open, dispatch]);

  if (!open) return null;

  return (
    <>
      <div className="more-spaces-backdrop" onClick={onClose} />

      <div className="more-spaces-popup">
        <div className="popup-header">
          <Typography variant="h4">More Projects</Typography>
        </div>

        <div className="popup-list">
          {loading && <div className="popup-item">Loading...</div>}

          {!loading &&
            list.map((item) => (
              <div key={item.id} className="popup-item">
                {item.projectName}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default MoreSpacesPopup;
